import { createApp } from 'vue';
import FlacToOpusConverter from '@/Components/FlacToOpusConverter.vue';
import '@styles/app.css';

createApp(FlacToOpusConverter).mount('#flac-to-opus-converter');
